import React from "react";
import { Box, Chip } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";

import { InitiativeListItemDTO } from "api";
import { DeleteIconButton } from "components";
import { formatCurrency, formatLocaleNumber, formatNullable } from "utils";
import { EMPTY_CELL_VALUE } from "consts";

import {
  INITIATIVE_STATUS_LABELS,
  INITIATIVE_STATUS_BG_COLORS,
  INITIATIVE_STATUS_TEXT_COLORS,
} from "./consts";

export const getInitiativesColumns = (
  onDelete: (id: number) => void,
): MRT_ColumnDef<InitiativeListItemDTO>[] => [
  {
    accessorKey: "name",
    header: "Initiative Name",
  },
  {
    id: "businessUnit",
    header: "Business Unit",
    accessorFn: (row) =>
      row.level === "BUSINESS_UNIT" ? row.entity : EMPTY_CELL_VALUE,
  },
  {
    id: "site",
    header: "Site",
    accessorFn: (row) => (row.level === "SITE" ? row.entity : EMPTY_CELL_VALUE),
  },
  {
    accessorKey: "capex",
    header: "Cost (Est.)",
    accessorFn: (row) => formatNullable(row.capex, formatCurrency),
  },
  {
    accessorKey: "annualGrossSavings",
    header: "Annual Savings",
    accessorFn: (row) => formatNullable(row.annualGrossSavings, formatCurrency),
  },
  {
    accessorKey: "roi",
    header: "ROI",
    accessorFn: (row) =>
      formatNullable(row.roi, (v) => `${formatLocaleNumber(v)}%`),
  },
  {
    accessorKey: "simplePayback",
    header: "Payback",
    accessorFn: (row) =>
      formatNullable(row.simplePayback, (v) => `${formatLocaleNumber(v)} yrs`),
  },
  {
    accessorKey: "status",
    header: "Status",
    Cell: ({ row }) => {
      const { status } = row.original;
      return (
        <Chip
          label={INITIATIVE_STATUS_LABELS[status]}
          size="small"
          sx={{
            backgroundColor: INITIATIVE_STATUS_BG_COLORS[status],
            color: INITIATIVE_STATUS_TEXT_COLORS[status],
            borderRadius: "6px",
            fontWeight: 500,
            fontSize: "0.75rem",
          }}
        />
      );
    },
  },
  {
    accessorKey: "owners",
    header: "Owners",
    accessorFn: (row) => {
      const { owners } = row;
      if (!owners || owners.length === 0) return EMPTY_CELL_VALUE;
      const remaining = owners.length - 1;
      return remaining > 0 ? `${owners[0]} +${remaining}` : owners[0];
    },
  },
  {
    id: "actions",
    header: "Actions",
    enableColumnFilter: false,
    enableSorting: false,
    Cell: ({ row }) => (
      <Box
        role="presentation"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <DeleteIconButton onClick={() => onDelete(row.original.id)} />
      </Box>
    ),
  },
];
